import { Box, Typography } from "@mui/material";
import EngineeringIcon from "@mui/icons-material/Engineering";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import SecurityIcon from "@mui/icons-material/Security";
import SettingsIcon from "@mui/icons-material/Settings";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

const departments = [
  {
    name: "Fabrication & Welding",
    icon: <EngineeringIcon sx={{ fontSize: 32, color: brandRed }} />,
  },
  {
    name: "Design & Engineering (AutoCAD)",
    icon: <DesignServicesIcon sx={{ fontSize: 32, color: brandRed }} />,
  },
  {
    name: "Quality Assurance",
    icon: <SecurityIcon sx={{ fontSize: 32, color: brandRed }} />,
  },
  {
    name: "Project Management",
    icon: <SettingsIcon sx={{ fontSize: 32, color: brandRed }} />,
  },
  {
    name: "Production & Materials Handling",
    icon: <LocalShippingIcon sx={{ fontSize: 32, color: brandRed }} />,
  },
];

const DepartmentsOverview = () => {
  return (
    <Box sx={{ py: 12, px: { xs: 2, md: 6 }, background: "#f9f9f9" }}>
      <Typography
        variant="h4"
        fontWeight={700}
        align="center"
        sx={{
          mb: { xs: 1, md: 1 }, // smaller margin on mobile
          color: brandBlue,
          fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.2rem" }, // responsive font size
          lineHeight: { xs: 1.3, md: 1.4 }, // better readability on small screens
        }}
      >
        Explore Our Departments
      </Typography>

      <Box
        sx={{
          width: 90,
          height: 4,
          background: brandRed,
          mx: "auto",
          borderRadius: 2,
          mb: { xs: 4, md: 8 },
        }}
      />

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 4,
        }}
      >
        {departments.map((dep, idx) => (
          <Box
            key={idx}
            sx={{
              flex: "1 1 220px",
              maxWidth: 260,
              minHeight: 130,
              background: "#fff",
              borderRadius: 4,
              p: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: 600,
              fontSize: "1rem",
              color: brandBlue,
              boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
              cursor: "pointer",
              transition: "all 0.35s ease",
              backgroundImage: "linear-gradient(145deg, #ffffff, #f0f4ff)",
              "&:hover": {
                transform: "translateY(-6px) scale(1.02)",
                boxShadow: `0 15px 35px rgba(0,0,0,0.15)`,
              },
            }}
          >
            <Box
              sx={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                background: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
            >
              {dep.icon}
            </Box>
            <Typography>{dep.name}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default DepartmentsOverview;
